import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisRequest = ApiDefinition['/ai/filing-district']['GET'];
type Input = ThisRequest['query'];
type Output = ThisRequest['response'];

const getFilingDistrict = async ({ zipCode, fieldKey, questionnaireId }: Input): Promise<Output> => {
  if (!zipCode || !fieldKey || !questionnaireId) {
    return '';
  }
  const response = await noodleApiClient.get('/ai/filing-district', {
    params: { fieldKey, questionnaireId, zipCode },
  });
  return response.data;
};

export default getFilingDistrict;
